// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chip-status {
  box-sizing: border-box;
  border-radius: 4px;
  font-weight: var(--regular_weight);
}
.chip-status::first-letter {
  text-transform: uppercase;
}
.chip-status.small {
  font-size: 10px;
  padding: 4px 6px;
}
.chip-status.large {
  font-size: 14px;
  padding: 4px 8px;
}
.chip-status.done {
  background-color: #cdffc7;
  color: #0f8701;
  border: #0f8701 1px solid;
}
.chip-status.draft {
  color: #4c5567;
  border: #4c5567 1px solid;
}
.chip-status.zai {
  background: var(--color_zai);
  color: var(--color_neutral_0);
  border: var(--color_zai_hover) 1px solid;
}`, "",{"version":3,"sources":["webpack://./src/components/ChipStatus/index.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,kBAAA;EACA,kCAAA;AACF;AACE;EACE,yBAAA;AACJ;AAEE;EACE,eAAA;EACA,gBAAA;AAAJ;AAGE;EACE,eAAA;EACA,gBAAA;AADJ;AAIE;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AAFJ;AAKE;EACE,cAAA;EACA,yBAAA;AAHJ;AAME;EACE,4BAAA;EACA,6BAAA;EACA,wCAAA;AAJJ","sourcesContent":[".chip-status {\n  box-sizing: border-box;\n  border-radius: 4px;\n  font-weight: var(--regular_weight);\n\n  &::first-letter {\n    text-transform: uppercase;\n  }\n\n  &.small {\n    font-size: 10px;\n    padding: 4px 6px;\n  }\n\n  &.large {\n    font-size: 14px;\n    padding: 4px 8px;\n  }\n\n  &.done {\n    background-color: #cdffc7;\n    color: #0f8701;\n    border: #0f8701 1px solid;\n  }\n\n  &.draft {\n    color: #4c5567;\n    border: #4c5567 1px solid;\n  }\n\n  &.zai {\n    background: var(--color_zai);\n    color: var(--color_neutral_0);\n    border: var(--color_zai_hover) 1px solid;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
